module.exports = __webpack_public_path__ + "img/Nora/Nora-apple-icon-152x152.png";